<template>
  <div class="form banner">
    <el-form
      ref="form"
      label-width="240px"
      label-position="left"
      :model="formData"
      :rules="rules"
    >
      <!-- <el-form-item :label="language('shopBannerForm.shop')" prop="shopNum">
        <div class="input">
          <el-select v-model="formData['shopNum']" placeholder="">
            <el-option
              v-for="item in shop"
              :key="item.value"
              :label="item.nameChi"
              :value="item.shopNum"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item> -->
      <el-form-item :label="language('shopBannerForm.nameChi')" prop="nameChi">
        <div class="input">
          <el-input v-model="formData['nameChi']"></el-input>
        </div>
      </el-form-item>
      <el-form-item :label="language('shopBannerForm.nameEng')" prop="nameEng">
        <div class="input">
          <el-input v-model="formData['nameEng']"></el-input>
        </div>
      </el-form-item>
      <!-- <el-form-item :label="language('shopBannerForm.status')" prop="status">
        <div class="input">
          {{ formData["status"] }}
        </div>
      </el-form-item> -->
      <el-form-item :label="language('shopBannerForm.order')" prop="order">
        <div class="input">
          <el-input v-model="formData['order']" type="number"></el-input>
        </div>
      </el-form-item>
      <el-form-item
        :label="language('shopBannerForm.linkToBanner')"
        prop="linkTo"
      >
        <div class="input">
          <div>
            <el-select v-model="articleType" placeholder="">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="add" v-if="articleType">
            <el-input placeholder="" v-model="formData.articleName" disabled>
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="open"
              ></el-button>
            </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="language('shopBannerForm.display')" prop="display">
        <div class="input">
          <!-- <el-input v-model="formData['display']"></el-input> -->
          <el-select v-model="formData['display']" placeholder="">
            <el-option
              v-for="item in display"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="WebImg" prop="webImg">
        <div class="input">
          <cc-uploader
            :config="uploaderConf"
            v-model="formData['webImg']"
            fType="image"
            :info="language('common.uploaderInfo')"
            :fFormatV2="['.jpg', '.png']"
          />
        </div>
      </el-form-item>
      <el-form-item label="AppImg" prop="appImg">
        <div class="input">
          <cc-uploader
            :config="uploaderConf"
            v-model="formData['appImg']"
            fType="image"
            :info="language('common.uploaderInfo')"
            :fFormatV2="['.jpg', '.png']"
          />
        </div>
      </el-form-item>
      <el-form-item
        :label="language('shopBannerForm.startTime')"
        prop="startTime"
      >
        <el-date-picker v-model="formData['startTime']" type="datetime">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="language('shopBannerForm.endTime')" prop="endTime">
        <el-date-picker v-model="formData['endTime']" type="datetime">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">{{
          language("shopCampaign.save")
        }}</el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      :title="language('shopBannerForm.content')"
      :visible.sync="dialog"
      :close-on-click-modal="false"
      width="90%"
      append-to-body
    >
      <!---商品--->
      <template v-if="articleType == 'product'">
        <cc-search
          :config="searchConfig"
          @doSearch="doSearch"
          size="medium"
        ></cc-search>
        <cc-table
          :loadData="true"
          :config="table"
          :params="params"
          :refeshParams="refeshTable"
          :showIndex="false"
          :buttonsWidth="100"
          :emptyText="language('productDetails.emptyText')"
        ></cc-table>
      </template>

      <!---促銷--->
      <template v-if="articleType == 'marketing'">
        <cc-search
          :config="searchPromotionConfig"
          @doSearch="doSearch"
          size="medium"
        ></cc-search>
        <cc-table
          :loadData="true"
          :config="tablePromotion"
          :params="paramsPromotion"
          :refeshParams="refeshTablePromotion"
          :showIndex="false"
          :buttonsWidth="100"
          :emptyText="language('productDetails.emptyText')"
        ></cc-table>
      </template>

      <!--分類--->
      <template v-if="articleType == 'category'">
        <cc-search
          :config="searchCategoryConfig"
          @doSearch="doSearch"
          size="medium"
        ></cc-search>
        <cc-table
          :loadData="true"
          :config="tableCategory"
          :params="paramsCategory"
          :refeshParams="refeshTableCategory"
          :showIndex="false"
          :buttonsWidth="100"
          :emptyText="language('productDetails.emptyText')"
        ></cc-table>
      </template>

      <!--標籤--->
      <template v-if="articleType == 'campaign'">
        <cc-search
          :config="searchCampaignConfig"
          @doSearch="doSearch"
          size="medium"
        ></cc-search>
        <cc-table
          :loadData="true"
          :config="tableCampaign"
          :params="paramsCampaign"
          :refeshParams="refeshTableCampaign"
          :showIndex="false"
          :buttonsWidth="100"
          :emptyText="language('productDetails.emptyText')"
        ></cc-table>
      </template>



      <!---套裝商品--->
      <template v-if="articleType == 'book'">
        <cc-search
          :config="searchConfig"
          @doSearch="doSearch"
          size="medium"
        ></cc-search>
        <cc-table
          :loadData="true"
          :config="setDetailsTable"
          :params="setDetailsparams"
          :refeshParams="setDetailsrefeshTable"
          :showIndex="false"
          :buttonsWidth="100"
          :emptyText="language('productDetails.emptyText')"
        ></cc-table>
      </template>


    </el-dialog>
  </div>
</template>
<script>
import uploadUtils from "../../../utils/ossUtils";
export default {
  props: {
    editData: Object,
  },
  data() {
    return {
      shopData: {},
      formData: {},
      articleType: "",
      uploaderConf: uploadUtils.configPublish,
      options: [
        {
          value: "marketing", //促銷
          label: "Promotion",
        },
        {
          value: "product", // 產品
          label: "Product",
        },
        {
          value: "book", // 套裝
          label: "Set Details",
        },
        {
          value: "category",
          label: "Category",
        },
        {
          value: "campaign",
          label: "Campaign",
        },
      ],
      display: [
        {
          value: 0,
          label: this.language("shopBannerForm.invisible"),
        },
        {
          value: 1,
          label: this.language("shopBannerForm.visible"),
        },
      ],
      dialog: false,
      table: {
        api: "admin/merchant/product/query?status=1&isQueryProductSale=1",
        showPager: true,
        columns: [
          {
            minWidth: 110,
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            minWidth: 120,
            prop: "auditStatus",
            lable: "Status",
            type: "tag",
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "type",
            type: "tag",
            minWidth: 190,
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "barcode",
            lable: "SKU ID（Barcode）",
            minWidth: 150,
          },
          {
            prop: "name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
          },
          {
            prop: "categories",
            lable: "Category（System）",
            minWidth: 120,
          },
          {
            prop: "brand",
            lable: "Brand",
            minWidth: 120,
          },
          {
            prop: "listPrice",
            lable: "OriginalPrice",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.listPrice, 2);
            },
            minWidth: 100,
          },
          {
            prop: "updateAdminId",
            lable: "Update By",
            minWidth: 100,
          },
          {
            prop: "updateTime",
            lable: "Last Update",
            minWidth: 150,
          },
          {
            prop: "createTime",
            lable: "Create Date",
            minWidth: 200,
          },
        ],
        buttons: [
          {
            name: this.language("shopBannerForm.select"),
            click: (row, index) => {
              this.settingForm(row);
            },
          },
        ],
      },
      params: {},
      refeshTable: -1,

      tablePromotion: {
        api: "admin/merchant/marketing/query",
        showPager: true,
        columns: [
          {
            prop: "createTime",
            lable: this.language("promotionRules.createTime"),
            minWidth: 200,
          },
          {
            prop: "activityType",
            lable: this.language("promotionRules.activityType"),
            type: "tag",
            minWidth: 190,
            options: {
              flashSale: {
                tagType: "success",
                text: "BasicDiscounts",
              },
              MChooseN: {
                tagType: "success",
                text: "MChooseN",
              },
              buyMoreGetMore: {
                tagType: "success",
                text: "BuyMoreGetMore",
              },
            },
          },
          // {
          //   prop: "id",
          //   lable: "ID",
          //   minWidth: 230,
          // },
          {
            prop: "activityName",
            lable: this.language("promotionRules.activityName"),
            minWidth: 150,
          },
          // {
          //   prop: "activityDesc",
          //   lable: this.language("promotionRules.promotionDescription"),
          // },
          // {
          //   prop: "mchShopNum",
          //   lable: "mchShopNum",
          // },
          {
            prop: "startTime",
            lable: this.language("promotionRules.startTime"),
            minWidth: 220,
          },
          {
            prop: "endTime",
            lable: this.language("promotionRules.endTime"),
            minWidth: 210,
          },
          {
            prop: "status",
            lable: this.language("promotionRules.status"), //0無效 1有效
            type: "tag",
            minWidth: 80,

            options: {
              0: {
                tagType: "danger",
                text: this.language("promotionRules.off"),
              },
              1: {
                tagType: "success",
                text: this.language("promotionRules.on"),
              },
              2: {
                tagType: "info",
                text: this.language("promotionRules.draft"),
              },
            },
          },
        ],
        buttons: [
          {
            name: this.language("shopBannerForm.select"),
            click: (row, index) => {
              this.settingForm(row);
            },
          },
        ],
      },
      paramsPromotion: {},
      refeshTablePromotion: -1,
      searchPromotionConfig: [
        {
          title: this.language("promotionRules.activityName"),
          fieldName: "activityName",
          style: "text",
          displayName: "",
        },
        {
          title: this.language("promotionRules.activityType"),
          fieldName: "activityType",
          style: "select",
          displayName: "",

          options: [
            {
              label: "flashSale",
              value: "BasicDiscounts",
            },
            {
              label: "MChooseN",
              value: "FixedPriceInQty",
            },
            {
              label: "BuyMoreGetMore",
              value: "BuyMoreGetMore",
            },
          ],
        },
      ],
      searchConfig: [
        {
          title: "SKU ID / Barcode",
          fieldName: "barcode",
          style: "text",
          displayName: "",
        },
        {
          title: "Product Name",
          fieldName: "name",
          style: "text",
          displayName: "",
        },
      ],
      rules: {
        nameChi: [
          {
            required: true,
            message: this.language("shopBannerForm.nameChiTips"),
            trigger: "blur",
          },
        ],
        shopNum: [
          {
            required: true,
            message: this.language("shopBannerForm.shopNumTips"),
            trigger: "blur",
          },
        ],
        display: [
          {
            required: true,
            trigger: "blur",
            message: this.language("shopBannerForm.displayTips"),
          },
        ],
        linkTo: [
          {
            required: true,
            // message: "Link to Banner is required",
            trigger: "blur",
            message: this.language("shopBannerForm.linkToTips"),
          },
        ],
        webImg: [
          {
            required: true,
            trigger: "blur",
            message: this.language("shopBannerForm.webImgTips"),
          },
        ],
        appImg: [
          {
            required: true,
            message: this.language("shopBannerForm.appImgTips"),
            trigger: "blur",
          },
        ],
        endTime: [
          {
            required: true,
            message: this.language("shopBannerForm.endTimeTips"),
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: this.language("shopBannerForm.startTimeTips"),
            trigger: "blur",
          },
        ],
      },

      //分類
      searchCategoryConfig: [
        {
          title: this.language("shopBannerForm.categoryName"),
          fieldName: "name",
          style: "text",
          displayName: "",
        },
        {
          title: this.language("shopBannerForm.categoryCode"),
          fieldName: "code",
          style: "text",
          displayName: "",
        },
      ],
      tableCategory: {
        api: "admin/merchant/category/queryHasPrd",
        showPager: true,

        columns: [
          // {
          //   prop: "id",
          //   lable: "ID",
          // },
          // {
          //   prop: "code",
          //   minWidth: 50,
          //   lable: this.language("shopCategory.code"),
          // },
          {
            prop: "sort",
            lable: this.language("shopCategory.sort"),
            minWidth: 80,
          },
          {
            prop: "name",
            lable: this.language("shopCategory.nameChi"),
            minWidth: 100,
          },
          {
            prop: "nameEn",
            lable: this.language("shopCategory.nameEng"),
            minWidth: 100,
          },
          {
            prop: "code",
            minWidth: 50,
            lable: this.language("shopCategory.code"),
          },
          // {
          //   prop: "cateType",
          //   lable: this.language("shopCategory.cateType"),
          // },
          {
            prop: "parentId",
            lable: this.language("shopCategory.parentId"),
            minWidth: 80,
          },

          {
            prop: "isShow",
            lable: this.language("shopCategory.isShow"),

            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("shopCategory.visible"),
              },
              0: {
                tagType: "danger",
                text: this.language("shopCategory.invisible"),
              },
            },
          },

          {
            prop: "status",
            lable: this.language("shopCategory.displayed"),

            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("shopCategory.visible"),
              },
              0: {
                tagType: "danger",
                text: this.language("shopCategory.invisible"),
              },
              2: {
                tagType: "danger",
                text: this.language("shopCampaign.forbidden"),
              },
            },
          },
        ],
        buttons: [
          {
            name: this.language("shopBannerForm.select"),
            click: (row, index) => {
              this.settingForm(row);
            },
          },
        ],
      },
      paramsCategory: {},
      refeshTableCategory: -1,

      //標籤
      searchCampaignConfig: [
        {
          title: this.language("shopBannerForm.campaignName"),
          fieldName: "name",
          style: "text",
          displayName: "",
        },
        {
          title: this.language("shopBannerForm.campaignCode"),
          fieldName: "code",
          style: "text",
          displayName: "",
        },
      ],
      tableCampaign: {
        api: "admin/merchant/tag/queryHasPrd",
        showPager: true,
        columns: [
          // {
          //   prop: "id",
          //   lable: "ID",
          // },
          {
            prop: "sort",
            lable: this.language("shopCampaign.sort"),
            minWidth: 80,
          },

          {
            prop: "name",
            lable: this.language("shopCampaign.nameChi"),
            minWidth: 150,
          },
          {
            prop: "nameEn",
            lable: this.language("shopCampaign.nameEng"),
            minWidth: 150,
          },
          {
            prop: "code",
            lable: this.language("shopCampaign.code"),
            minWidth: 50,
          },
          // {
          //   prop: "parentId",
          //   lable: this.language("shopCampaign.parentId"),
          // },

          {
            prop: "isShow",
            lable: this.language("shopCampaign.isShow"),
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("shopCategory.visible"),
              },
              0: {
                tagType: "danger",
                text: this.language("shopCategory.invisible"),
              },
            },
          },

          {
            prop: "status",
            lable: this.language("shopCampaign.displayed"),
            type: "tag",
            options: {
              1: {
                tagType: "success",
                text: this.language("shopCampaign.visible"),
              },
              0: {
                tagType: "danger",
                text: this.language("shopCampaign.invisible"),
              },
              2: {
                tagType: "danger",
                text: this.language("shopCampaign.forbidden"),
              },
            },
          },
        ],
        buttons: [
          {
            name: this.language("shopBannerForm.select"),
            click: (row, index) => {
              this.settingForm(row);
            },
          },
        ],
      },
      paramsCampaign: {},
      refeshTableCampaign: -1,

      //套裝
      setDetailsSearchConfig:[],
      setDetailsTable:{
        api: "admin/merchant/product/queryPackage?isPackage=1&auditStatus=1&isQueryProductSale=1",
        showPager:true,
        columns: [
          {
            prop: "saleStatus",
            lable: "Displayed",
            type: "tag",
            minWidth: 110,
            options: {
              1: {
                tagType: "success",
                text: this.language("productDetails.online"),
              },
              0: {
                tagType: "info",
                text: this.language("productDetails.offline"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.invisible"),
              },
              // 1: {
              //   tagType: "danger",
              //   text: "不支持线上销售",
              // },
              // 2: {
              //   tagType: "danger",
              //   text: "待上架",
              // },
            },
          },
          {
            prop: "auditStatus",
            lable: "Status",
            type: "tag",
            minWidth: 120,
            options: {
              0: {
                tagType: "info",
                text: this.language("productDetails.submit"),
              },
              1: {
                tagType: "success",
                text: this.language("productDetails.approved"),
              },
              2: {
                tagType: "danger",
                text: this.language("productDetails.rejected"),
              },
              // hide: {
              //   tagType: "danger",
              //   text: this.language("productDetails.hide"),
              // },
            },
          },
          {
            prop: "type",
            lable: "Type",
            type: "tag",
            minWidth: 130,
            options: {
              H: {
                tagType: "success",
                text: "Non Book",
              },
              C: {
                tagType: "success",
                text: "(Book) Mainland/國版",
              },
              D: {
                tagType: "success",
                text: "(Book) HKG/港版",
              },
              E: {
                tagType: "success",
                text: "(Book) TWN/台版",
              },
              F: {
                tagType: "success",
                text: "(Book) Others/外文版",
              },
              A: {
                tagType: "success",
                text: "(Book)SUP/本版",
              },
              'DT000': {
                tagType: "success",
                text: "PRY.HK/小學教參",
              },
              "DT100": {
                tagType: "success",
                text: "SEC.HK/中學教參",
              },
              "DT200": {
                tagType: "success",
                text: "UNI.HK/大專教參",
              },
              'FT000': {
                tagType: "success",
                text: "PRY.F/外文小學教參",
              },
              "FT100": {
                tagType: "success",
                text: "SEC.F/外文中學教參",
              },
              'FT200': {
                tagType: "success",
                text: "UNI.F/外文大專教參",
              },
            },
          },
          {
            prop: "mchProductId",
            lable: "Model ID",
            minWidth: 200,
          },

          {
            prop: "itemSize",
            lable: "Products",
            minWidth: 100,
          },
          {
            prop: "stock",
            lable: "Available Stocks",
            minWidth: 100,
          },
          {
            prop: "name",
            lable: "Product Name（Chi.）",
            minWidth: 180,
          },
          {
            prop: "cover",
            lable: "Product Cover",
            minWidth: 80,
            type: "img",
            urlPropName: "cover",
            sourceUrlPropName: "cover",
            // imgCompressParams: "?x-oss-process=image/resize,w_600",
            w: 40,
            h: 40,
          },
          // {
          //   prop: "categories",
          //   lable: "Category（System）",
          //   minWidth: 120,
          // },
          // {
          //   prop: "brand",
          //   minWidth: 120,
          //   lable: "Brand",
          // },
          {
            prop: "salePrice",
            lable: "Selling Price(HKD)",
            render: (rows) => {
              return this.$utils.toFixedDigit(rows.salePrice * 1, 2);
            },
            minWidth: 100,
          },
          {
            prop: "updateAdminName",
            lable: "Update By",
            minWidth: 100,
          },
          {
            prop: "updateTime",
            lable: "Last Update",
            minWidth: 200,
          },
          {
            prop: "createTime",
            lable: "Create Date",
            minWidth: 200,
          },
        ],
        buttons: [
          {
            name: this.language("shopBannerForm.select"),
            click: (row, index) => {
              this.settingForm(row);
            },
          },
        ],
      },
      setDetailsparams:{},
      setDetailsrefeshTable:-1


    };
  },
  watch: {
    articleType: {
      handler(value) {
        if (this.formData.articleType != this.articleType) {
          this.formData.articleName = "";
          this.formData.isbn = "";
          this.formData.type = "";
          this.formData.articleId = "";
          this.formData.linkTo = "";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    open() {
      this.params = {
        shopNum: this.$shopData.shopNum,
        mchShopNum: this.$shopData.shopNum,
      };
      this.paramsPromotion = {
        shopNum: this.$shopData.shopNum,
        mchShopNum: this.$shopData.shopNum,
      };
      this.paramsCategory = {
        shopNum: this.$shopData.shopNum,
        mchShopNum: this.$shopData.shopNum,
      };
      this.paramsCampaign = {
        shopNum: this.$shopData.shopNum,
        mchShopNum: this.$shopData.shopNum,
      };
      this.setDetailsparams={
        shopNum: this.$shopData.shopNum,
        mchShopNum: this.$shopData.shopNum,
      }
      this.dialog = true;
    },
    doSearch(e) {
      this.params = {
        ...e,
        mchShopNum: this.$shopData.shopNum,
        shopNum: this.$shopData.shopNum,
      };
      this.paramsPromotion = {
        ...e,
        mchShopNum: this.$shopData.shopNum,
        shopNum: this.$shopData.shopNum,
      };
      this.paramsCampaign = {
        ...e,
        mchShopNum: this.$shopData.shopNum,
        shopNum: this.$shopData.shopNum,
      };
      this.setDetailsparams={
        ...e,
        shopNum: this.$shopData.shopNum,
        mchShopNum: this.$shopData.shopNum,
      }
    },
    settingForm(e) {
      if (this.articleType == "product"  ) {
        this.formData["articleId"] = e.saleId;
        this.formData["articleName"] = e.name;
        this.formData["isbn"] = e.barcode;
        this.formData["type"] = e.type;
      } else if ( this.articleType == "book"  ) {
        console.log(e)
        this.formData["articleId"] = e.saleId;
        this.formData["articleName"] = e.name;
        this.formData["isbn"] = e.barcode;
        this.formData["type"] =  e.type;
      } else if (this.articleType == "marketing") {
        this.formData["articleId"] = e.id;
        this.formData["articleName"] = e.activityName;
      } else if (this.articleType == "category") {
        this.formData["articleId"] = e.id;
        this.formData["articleName"] = e.name;
        this.formData["type"] = "shopTagList";
      } else if (this.articleType == "campaign") {
        this.formData["articleId"] = e.id;
        this.formData["articleName"] = e.name;
        this.formData["type"] = "shopTagList";
      }
      this.formData.linkTo = e;
      this.dialog = false;
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (
            new Date(this.formData.startTime).getTime() >
            new Date(this.formData.endTime).getTime()
          ) {
            this.$message.error("開始時間大於結束時間");
            return false;
          }
          let data = {
            nameChi: this.formData.nameChi,
            nameEng: this.formData.nameEng,
            shopNum: this.formData.shopNum,
            webImg: this.formData.webImg,
            appImg: this.formData.appImg,
            order: this.formData.order,
            linkTo: {
              articleType: this.articleType,
              articleName: this.formData.articleName,
              type: this.formData.type,
              articleId: this.formData.articleId,
              id: this.formData.articleId,
              aliasName: this.shopData.aliasName,
              shopNum: this.formData.shopNum,
              isbn: this.formData.isbn,
            },
            display: this.formData.display,
            endTime: this.formData.endTime,
            startTime: this.formData.startTime,
          };
          if (this.formData.id) {
            data.id = this.formData.id;
          }
          console.log(data);
          this.ccRequest
            .do("admin/merchant/shop/banner/save", data, "POSTJSON")
            .then((res) => {
              this.$emit("success", true);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
    this.shopData = this.$shopData;

    if (this.editData.id) {
      this.formData = JSON.parse(JSON.stringify(this.editData));
      let linkTo = JSON.parse(this.editData.linkTo);
      this.formData.articleType = linkTo.articleType;
      this.formData.articleName = linkTo.articleName;
      this.formData.articleId = linkTo.articleId;
      this.formData.type = linkTo.type;
      this.articleType = linkTo.articleType;
      if (linkTo.isbn) {
        this.formData.isbn = linkTo.isbn;
      }
    }
    let url = "/perm/banner/";
    if (this.editData.id) {
      url = "/perm/banner/" + this.editData.id + "/";
    }
    this.uploaderConf = uploadUtils.configPublishV2(url);
    // console.log(this.uploaderConf);
    this.formData.shopNum = this.editData.shopNum;
  },
};
</script>
<style scoped>
.input {
  width: 400px;
}
.count_tips {
  margin: 10px 0 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.add {
  margin-top: 10px;
}
</style>
<style lang="scss">
.banner {
  .upload-btnV2 .upload-demo {
    margin-top: -21px !important;
  }
}
</style>
